module.exports = __webpack_public_path__ + "img/3.61b73a58.png";